import React from "react";
import "./Hero.css";
// import { storage } from "../../firebase/firebase";

// import heroVideo from "../../assets/videos/binkleyvid16.mp4";

function Hero() {
  const firebaseVideoUrl = "https://firebasestorage.googleapis.com/v0/b/binkley-preschool-website.firebasestorage.app/o/binkleyvid1.mp4?alt=media&token=be20c5d3-a157-476c-ba9a-96ecc742dcbd";
  return (
    <section className="hero-section">
      {/* Background video */}
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={firebaseVideoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Sticky content */}
      <div className="hero-sticky">
 
        <h1 className="hero-title">CELEBRATING 60 YEARS</h1>
        <p className="hero-text">
          Binkley Preschool is celebrating 60 years of nurturing young
          minds and is proud to call itself the oldest preschool in Chapel Hill.
        </p>
        <button
          className="hero-btn"
          onClick={() => (window.location.href = "/about")}
        >
          Learn more about Binkley
        </button>
      </div>
    </section>
  );
}

export default Hero;









// import React from "react";
// import { Parallax } from "react-scroll-parallax";
// import "./Hero.css";

// import herobg from "../../assets/backgrounds/herobackground2.png";
// import heroPhoto from "../../assets/Binkley_Logo_Color2.png";

// function Hero() {
//   console.log(herobg);
//   return (
//     <div className="hero-container">


//       {/* Parallax background image */}
//       {/* <Parallax speed={-20} className="background-img">
//         <img src={herobg} alt="Hero background image" className="hero-bg" />
//       </Parallax> */}

//       {/* Parallax text content */}
//       <Parallax speed={-10} className="hero-content">

//         <h1 className="hero-title">CELEBRATING 60 YEARS</h1>
//         <img src={heroPhoto} alt="Binkley Preschool Logo" className="hero-logo" />
//         <p className="hero-text">
//           Binkley Preschool is proud to celebrate 60 years of nurturing young minds and to call itself the oldest preschool in chapel hill. 
//         </p>
//         <button className="hero-btn" onClick={() => window.location.href = "/about"}> Learn more about Binkley! </button>
//       </Parallax>
//     </div>
//   );
// }

// export default Hero;
